import { MinimalTarget } from '@/generated/model';
import { getEndOfDayAsMicros, getStartOfDayAsMicros } from '@/utilities/timeUtils';

export function getPlateNumber(targets: MinimalTarget[] | undefined, targetID: number): string | undefined {
  return targets?.find((target) => {
    return target.id === targetID;
  })?.name;
}

export function mapAvaliableTargetIDs(targets: MinimalTarget[] | undefined): number[] {
  if (targets === undefined) return [];
  return targets.map((target) => target.id);
}

export function isClosedTarget(startTime: number, validityEndTimeMicros: number | undefined): boolean {
  const todayStart = getStartOfDayAsMicros(startTime * 1000);
  const validityEndDay = getEndOfDayAsMicros(validityEndTimeMicros);
  return validityEndDay < todayStart;
}
